<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" depressed="">
        {{ $t("credentialChangePassword") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{
          $t("profileDialogEditCredentialtitle")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form
        ref="formCheckPass"
        v-model="valid"
        lazy
        v-if="formCheckPassword"
        autocomplete="off"
      >
        <v-card-text>
          <v-alert :value="true" color="warning" icon="mdi-alert" text>
            {{ $t("profileDialogEditAlert") }}
          </v-alert>

          <v-text-field
            :class="[show ? 'show-password' : 'hide-password']"
            :label="$t('profileDialogEditPassword')"
            v-model="checkPassword"
            icon="lock"
            :rules="[rules.required]"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            type="text"
            @click:append="show = !show"
            prepend-icon="mdi-security"
            solo-inverted
            clearable
            autofocus
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>
          <v-btn text outlined="" @click="dialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            depressed=""
            type="submit"
            @click.prevent="checkPass"
            :disabled="!valid"
            :loading="loading"
          >
            {{ $t("BtnNext") }}
          </v-btn>
        </v-card-actions>
      </v-form>

      <v-form
        v-else
        ref="formCredential"
        v-model="valid2"
        lazy
        autocomplete="off"
      >
        <v-card-text>
          <v-alert :value="true" color="success" icon="mdi-alert" text>
            {{ $t("profileDialogEditChangePasswordAlert") }}
          </v-alert>
          <PasswordRules :rules="passwordRules" class="pb-4" />

          <div>
            <v-text-field
              :class="[show1 ? 'show-password' : 'hide-password']"
              v-model="newPassword"
              type="text"
              :label="$t('profileDialogEditNewPassword')"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              @click:append="show1 = !show1"
              required
              :counter="12"
              maxlength="12"
              solo-inverted
              clearable
              autofocus
            ></v-text-field>

            <v-text-field
              :class="[show2 ? 'show-password' : 'hide-password']"
              v-model="confirmNewPassword"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              type="text"
              :rules="passMatch"
              @click:append="show2 = !show2"
              required
              :counter="12"
              maxlength="12"
              solo-inverted
              clearable
            ></v-text-field>
          </div>
        </v-card-text>

        <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>
          <v-btn text @click="dialog = false" outlined="">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            type="submit"
            @click.prevent="editUser"
            depressed=""
            color="primary"
            :disabled="someError || !valid2"
            :loading="loading"
          >
            {{ $t("BtnSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/form-validate.js";
import qs from "qs";
import PasswordRules from '@/components/login/passwordRegistration/PasswordRules.vue';

export default {
  name: "dialogEditCredential",
  props: ["credential"],
  components: { PasswordRules },
  data: (vm) => ({
    dialog: false,
    valid: false,
    valid2: false,

    show: false,
    show1: false,
    show2: false,

    loading: false,

    // form confirm password
    checkPassword: "",
    hash: "",

    formCheckPassword: true,

    // form new password
    newPassword: "",
    confirmNewPassword: "",

    // Rules Default Import
    rules: {
      required: validate.required,
      passLength: validate.passLength,
      passCaracter: validate.passCaracter,
      passwordConfirm: validate.passwordConfirm,
      passRepeat: validate.passRepeat,
    },
    checkPasswordRules: {
      required: validate.required,
    },

    someError: false,

    passwordRules: {
      oneUppercaseLetter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneUppercaseLetter"),
        validate: (v) => /(?=.*?[A-Z])/.test(v),
      },
      oneLowercaseLetter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneLowercaseLetter"),
        validate: (v) => /(?=.*?[a-z])/.test(v),
      },
      oneSpecialCharacter: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneSpecialCharacter"),
        validate: (v) => /(?=.*?[#?!@$%^&*-])/.test(v),
      },
      oneNumber: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.oneNumber"),
        validate: (v) => /(?=.*?[0-9])/.test(v),
      },
      betweenEightAndTwelveCharacters: {
        error: true,
        message: "firstPasswordRegistration.rules.betweenEightAndTwelveCharacters",
        validate: (v) => v.length >= 8 && v.length <= 12,
      },
      confirmation: {
        error: true,
        message: vm.$t("firstPasswordRegistration.rules.confirmation"),
        validate: () =>
          vm.newPassword && vm.confirmNewPassword
            ? vm.newPassword === vm.confirmNewPassword
            : false,
      },
    },
  }),
  mounted() {},
  computed: {
    // Repet password
    passMatch() {
      const rules = [];
      // Required
      if (this.checkPasswordRules.required) {
        const rule = (v) => !!v || this.$t("ThisFieldIsRequired");
        rules.push(rule);
      }
      if (this.confirmNewPassword) {
        const rule = (v) =>
          (!!v && v) === this.newPassword || this.$t("repeatThePassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$emit("refresh-user");
      this.formCheckPassword = true;
    },
     "newPassword"() {
      this._checkPasswordRules();
    },
    "confirmNewPassword"() {
      this._checkPasswordRules();
    },
  },
  methods: {
    _checkPasswordRules() {
      for (const rule in this.passwordRules) {
        this.passwordRules[rule].error =
          this.passwordRules[rule].validate(
            this.newPassword ? this.newPassword : ""
          ) === false;
        this.someError = this.passwordRules[rule].error;
      }
    },
    formUpdated() {
      document.querySelector(".v-messages__wrapper").style.fontFamily =
        "Roboto";
    },
    // Confirmar Password Atual
    checkPass() {
      if (this.$refs.formCheckPass.validate()) {
        this.loading = true;
        const data = {
          password: this.checkPassword,
        };
        this.$axios
          .post("/player/profile/confirmPassword", this.$formdata(data))
          .then((response) => {
            const dados = response.data.dados;
            if (dados.hash) {
              this.hash = dados.hash; // armazena o hash

              this.formCheckPassword = false; // oculta form check pass

              this.$refs.formCheckPass.reset();
            } else {
              const msg = this.$t("somethingWrong");
              const color = "warning";
              this.$store.commit("setNotification", { msg, color });
            }
          })
          .catch(this.NotificationErrorDefault)
          .finally(() => (this.loading = false));
      } else {
        const msg = this.$t("reviewInformation");
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      }
    },

    // Editar Senha
    editUser() {
      if (this.$refs.formCredential.validate()) {
        this.loading = true;
        const data = {
          password: this.newPassword,
          hash: this.hash,
        };
        this.$axios
          .put("player/profile/editPassword", qs.stringify(data), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            const msg = response.data.messages;
            const color = "success";
            this.$store.commit("setNotification", { msg, color });
            this.dialog = false;
            this.formCheckPassword = true;
            this.formEditCredential = false;
            this.$refs.formCredential.reset();
          })
          .catch(this.NotificationErrorDefault)
          .finally(() => (this.loading = false));
      } else {
        const msg = this.$t("reviewInformation");
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      }
    },

    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg = error.response.data.messages[0];
      const color = "warning";
      this.$store.commit("setNotification", { msg, color });
    },
  },
};
</script>
